var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatanasc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H5.33333V14.6667H8V12ZM13.3333 12H10.6667V14.6667H13.3333V12ZM18.6667 12H16V14.6667H18.6667V12ZM21.3333 2.66667H20V0H17.3333V2.66667H6.66667V0H4V2.66667H2.66667C1.18667 2.66667 0.0133333 3.86667 0.0133333 5.33333L0 24C0 25.4667 1.18667 26.6667 2.66667 26.6667H21.3333C22.8 26.6667 24 25.4667 24 24V5.33333C24 3.86667 22.8 2.66667 21.3333 2.66667ZM21.3333 24H2.66667V9.33333H21.3333V24Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatanasc);
export default __webpack_public_path__ + "static/media/datanasc.abe0a715b3f0873b10a0921d3e90ba03.svg";
export { ForwardRef as ReactComponent };